# Hides an element and all descendants from assistive tech.
# Also removes descendants from the tab order, since focusable content
# inside aria-hidden is itself an accessibility violation.
# Usage: v-a11y-hidden  or  v-a11y-hidden="condition"

FOCUSABLE = [
  'a[href]', 'area[href]', 'button', 'input', 'select', 'textarea'
  'iframe', 'object', 'embed', 'summary', '[contenteditable]', '[tabindex]'
].join ','

ORIG = 'data-a11y-hidden-tabindex'

isOn = (binding) -> binding.value is undefined or !!binding.value

hide = (el) ->
  el.setAttribute 'aria-hidden', 'true' unless el.getAttribute('aria-hidden') is 'true'
  targets = [el.matches(FOCUSABLE) and el, el.querySelectorAll(FOCUSABLE)...].filter Boolean
  targets.forEach (node) ->
    return if node.getAttribute('tabindex') is '-1' and node.hasAttribute(ORIG)
    unless node.hasAttribute ORIG
      node.setAttribute ORIG, node.getAttribute('tabindex') ? ''
    node.setAttribute 'tabindex', '-1'
  return

show = (el) ->
  el.removeAttribute 'aria-hidden'
  targets = [el.hasAttribute(ORIG) and el, el.querySelectorAll("[#{ORIG}]")...].filter Boolean
  targets.forEach (node) ->
    orig = node.getAttribute ORIG
    if orig is '' then node.removeAttribute 'tabindex' else node.setAttribute 'tabindex', orig
    node.removeAttribute ORIG
  return

startObserver = (el) ->
  return if el._a11yHiddenObserver
  el._a11yHiddenObserver = new MutationObserver -> hide el
  el._a11yHiddenObserver.observe el,
    childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex']
  return

stopObserver = (el) ->
  el._a11yHiddenObserver?.disconnect()
  delete el._a11yHiddenObserver
  return

sync = (el, binding) ->
  if isOn binding
    hide el
    startObserver el
  else
    stopObserver el
    show el
  return

export default
  inserted: (el, binding) -> sync el, binding
  componentUpdated: (el, binding) -> sync el, binding
  unbind: (el) ->
    stopObserver el
    show el
    return